import React from 'react';

function pinImageName(order) {
    switch (order.orderStatus) {
        case 'new':
        case 'waitingForPickup':
        case 'assigned':
            return 'pickup';
        case 'pickedUp':
        case 'onWayToDelivery':
        case 'waitingForReturn':
            return 'delivery';
        default:
            return 'delivery';
    }
}

export function OrderPin({ order }) {
    const name = pinImageName(order);
    const title = (name.charAt(0).toUpperCase() + name.slice(1)) + ' Point';
    const orderStatus = order.orderStatus.toLowerCase()=='new'?'unassigned':order.orderStatus.toLowerCase();
    return (<span className="item_count_label" ><img className="pin-icon" src={`./${orderStatus.toLowerCase()}_regular.svg`} title={title}/> 
    <span className={(order.items && (order.items.length==1))?"hidden":""}>{order.items?order.items.length:''}</span></span>);
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/OrderPin.js